import { Node } from "@tiptap/core";
import {
  ReactNodeViewRenderer,
  NodeViewWrapper,
  NodeViewContent,
} from "@tiptap/react";
import React, { useState } from "react";
import { ShieldCheck, ChevronDown, ChevronRight } from "lucide-react";

export const SpecialConditions = Node.create({
  name: "specialConditions",

  group: "block",
  content: "block+",
  atom: false,
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      id: { default: null },
      title: { default: "Special Conditions" },
      expanded: { default: true },
    };
  },

  parseHTML() {
    return [{ tag: "special-conditions" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", { class: "special-conditions-block" }, HTMLAttributes.title];
  },

  addCommands() {
    return {
      insertSpecialConditions:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              id: crypto.randomUUID(),
              title: "Special Conditions",
              expanded: true,
            },
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    type: "text",
                    text: "Add special conditions...",
                  },
                ],
              },
            ],
          });
        },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(SpecialConditionsView);
  },
});
function SpecialConditionsView({ node, updateAttributes, selected }) {
  const [open, setOpen] = useState(true);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    updateAttributes({ expanded: next });
  };

  return (
    <NodeViewWrapper
      className={`
        my-3 rounded-xl border shadow-sm
        ${selected ? "border-[#375AE7]" : "border-slate-200"}
        bg-white overflow-hidden
      `}
    >
      {/* HEADER */}
      <div
        onClick={toggle}
        className="
          flex items-center justify-between
          px-4 py-2 bg-gradient-to-r from-[#EEF1FD] to-white
          cursor-pointer
        "
      >
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-[#375AE7]" />
          <span className="text-sm font-semibold text-slate-700">
            Special Conditions
          </span>
        </div>

        {open ? (
          <ChevronDown className="h-4 w-4 text-slate-500" />
        ) : (
          <ChevronRight className="h-4 w-4 text-slate-500" />
        )}
      </div>

      {/* BODY (THIS IS WHERE TYPING HAPPENS) */}
      {open && (
        <div className="px-5 py-3">
          <NodeViewContent
            as="div"
            className="
    prose prose-sm max-w-none
    min-h-[60px] outline-none
  "
          />
        </div>
      )}
    </NodeViewWrapper>
  );
}